import { axiosInstance } from '../api';

/**
 * Creates a finding via the admin-only /api/study/finding endpoint.
 * This bypasses the normal study creation flow (which requires a researcher user
 * and full study validation) and directly creates a finding.
 */
export default function(findingsData, heroImage) {
    const formData = new FormData();
    const information = {
        finalized: true,
        studyInfo: {
            title: findingsData.title,
            summary: findingsData.description,
            category: [],
        },
        findingProvincialLocation: findingsData.location,
        findingAuthorIdentities: findingsData.authors,
        findingPublishDate: findingsData.publishDate,
    };

    formData.append('information',
        new Blob([JSON.stringify(information)], { type: 'application/json' })
    );

    if (heroImage) {
        formData.append('image', heroImage);
    }

    return axiosInstance.post('/api/study/finding', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}
